//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "GiftCardPreviewPhysical",
  inject: [
    'giftCardData'
  ],
  computed: {
    giftCardNote() {
      return this.giftCardData.giftcard_note?.replace(/\n/g, "<br />");
    }
  }
}
